import { useEffect, useState } from 'react';
import { statusAPI } from '../api/status';

export function useVersion(): string {
  const [version, setVersion] = useState<string>('...');

  useEffect(() => {
    statusAPI.getStatus().then((status) => {
      const v = status.version || 'unknown';
      setVersion(v);
    });
  }, []);

  return version;
}
